export const RESET_CLAN = 'clan/RESET'

export function resetClan() {
    return {
        type: RESET_CLAN,
    }
}



// WEBPACK FOOTER //
// ./state/actions/clan.js